import React from "react";
import BlogListings from "components/Blog/BlogListings";
import PageHeader from "components/PageHeader";
import Section from "components/Section";

const BlogListingsPage = () => {
    return(
        <>
        <PageHeader/>

        <Section title="Hírek">
            <BlogListings/>
        </Section>
        
        </>
    )
}

export default BlogListingsPage;